import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { DealAttributeDefinitionApiService } from '../services/deal-attribute-definition-api.service';
import { DealAttributeDefinitionResponse } from '../models/deal-attribute-definition.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-deal-attribute-definition-list',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, PageBreadcrumbComponent, HasPermissionDirective],
  templateUrl: './deal-attribute-definition-list.component.html',
})
export class DealAttributeDefinitionListComponent implements OnInit {
  items: DealAttributeDefinitionResponse[] = [];
  loading = false;
  error = '';

  /** Diccionario único de tipos de atributo del módulo (nunca pintar la llave cruda). */
  private readonly typeLabels: Readonly<Record<string, string>> = {
    text: 'Texto',
    number: 'Número',
    boolean: 'Sí / No',
    list: 'Lista'
  };

  getTypeLabel(type: string | null | undefined): string {
    if (!type) return '—';
    return this.typeLabels[type] ?? type;
  }

  constructor(
    private api: DealAttributeDefinitionApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    const businessId = this.authService.getCurrentUser()?.businessId;
    if (!businessId) {
      this.error = 'No se pudo obtener el negocio del usuario';
      return;
    }

    this.loading = true;
    this.error = '';

    this.api.getAll(businessId).subscribe({
      next: (data) => {
        this.items = data.content;
        this.loading = false;
      },
      error: (err) => {
        this.error =
          err.error?.message || 'Error al cargar los campos personalizados';
        this.loading = false;
        console.error('Error:', err);
      },
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-deals/definiciones/crear']);
  }

  editar(item: DealAttributeDefinitionResponse): void {
    this.router.navigate(['/config-deals/definiciones/editar', item.id]);
  }

  async eliminar(item: DealAttributeDefinitionResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar campo',
      message: `¿Está seguro de eliminar el campo "${item.name}"?`,
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Campo personalizado', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.confirmDialog.alert({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar el campo',
          variant: 'danger',
        });
        this.toast.error({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar el campo',
        });
      },
    });
  }
}
